import { navigation } from './mock/navbarData.js';

angular.module('Toke').factory('navbarRepository', function ($q) {

    function getNavigation() {
        return $q.resolve(navigation)
    }

    // para lista futura
    // function getNavigationFromList() {

    //     const listUrl =
    //         baseUrl +
    //         "/_api/web/lists/getbytitle('Navbar')/items" +
    //         "?$select=Title,Url,ParentId,Order,IsActive" +
    //         "&$orderby=Order asc";

    //     return $http({
    //         method: 'GET',
    //         url: listUrl,
    //         headers: {
    //             Accept: 'application/json;odata=nometadata'
    //         }
    //     }).then(function (response) {
    //         return response.data.value;
    //     });
    // }



    return {
        getNavigation: getNavigation
    };

});

